export default __webpack_public_path__ + "e5b3eb377f6db9769b1ed8897927bb9b.png";